import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from "vue";
    import { Vehicle } from "src/types/loan-application/index";
    import  { useCurrencyFormatter } from 'src/functions';
    import DataTable from "src/components/form/forms/DataTable.vue";
    import GlassesValuationForm from "src/components/form/forms/GlassValuationsForm.vue";
    import CapValuationsForm from "src/components/form/forms/CapValuationsForm.vue";
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ValuationsDetailsForm',
  props: {
      modelValue: {
        type: Object as PropType<Vehicle>,
        default: {} as Vehicle
      },
      showTitle: {
        type: Boolean,
        default: true
      },
    },
  emits: [
      'update:modelValue'
    ],
  setup(__props, { emit: __emit }) {

    const props = __props
  
  
    const value = computed<Vehicle>({
      get() {
        return props.modelValue
      },
      set(value: Vehicle) {
        emit('update:modelValue', value)
      }
    })
  
    const emit = __emit
  
return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card, { bordered: "" }, {
      default: _withCtx(() => [
        _createVNode(GlassesValuationForm, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "q-mt-md" }, null, -1)),
    _createVNode(_component_q_card, { bordered: "" }, {
      default: _withCtx(() => [
        _createVNode(CapValuationsForm, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}
}

})